export default function isReadOnlyProperty(name, definitions) {
	return definitions[name] && definitions[name].readOnly;
}
